<template>
    <div v-if="showStep" class="g-mb-5">
        <generic-step-card
            :title="stepTitle"
            :current-step-name="currentStepName"
            :step="step"
            :is-preview="isPreview"
            :is-brief-accepted="isBriefAccepted"
            :is-brief-editable="isBriefEditable"
            :brief="brief"
            :sub-title="subtitle"
            :pad-around="false"
            :set-route="viewRoute"
        >
            <template #details>
                <product-preview
                    v-if="isBriefAccepted && findExistingOrder"
                    :brief="brief"
                    :order="findExistingOrder"
                    :products="products"
                    @click.stop="$router.push({ name: 'v2.activation.brief.order', params: { order_id: findExistingOrder.id } })"
                />
                <product-selected-preview
                    v-if="isComplete && !isBriefAccepted"
                    :order="findExistingOrder"
                    :products="products"
                />

                <div v-if="canAddAdditionalOrders">
                    <g-divider />

                    <g-button
                        class="g-w-full g-text-bold"
                        @click.stop="addAdditionalOrder"
                    >
                        <g-icon name="plus" size="large" />
                        Add Order
                    </g-button>
                </div>
            </template>
        </generic-step-card>
    </div>
</template>

<script>
    import GenericStepCard from '../GenericStepCard';
    import {NAME_PRODUCTS} from '../../../../../constants/activation-brief-steps';
    import StepCardViewMixin from '../mixins/StepCardViewMixin';
    import ActivationBriefProductConfigMixin from '../../mixins/ActivationBriefProductConfigMixin';
    import ProductPreview from '../products/ProductPreview';
    import {pluralize} from '../../../../../helpers/string-helpers';
    import ProductSelectedPreview from '../products/ProductSelectedPreview';
    import ActivationBriefOrderMixin from '../../mixins/ActivationBriefOrderMixin';
    import ActivationBriefProductsMixin from "../../../../providers/mixins/ActivationBriefProductsMixin";

    export default {
        name:       'ProductsStepCardView',
        components: {
            ProductSelectedPreview,
            ProductPreview,
            GenericStepCard,
        },
        mixins: [
            StepCardViewMixin,
            ActivationBriefProductConfigMixin,
            ActivationBriefProductsMixin,
            ActivationBriefOrderMixin,
        ],
        props: {
            products: {
                type: Array,
            },
        },
        computed: {
            stepName() {
                return NAME_PRODUCTS;
            },
            subtitle() {
                if (this.isComplete && this.isBriefEditable){
                    const count = this.findExistingOrder.items.length;
                    return `${count} ${pluralize(count, 'Item')} Selected`;
                }
                else if (this.isBriefEditable) {
                    return this.getConfigText;
                }
                const count = this.findExistingOrders.length;
                return `${count} ${pluralize(count, 'Order')}`;
            },
            viewRoute() {
                return this.isBriefAccepted ? 'orders' : null;
            }
        },
        methods: {
            addAdditionalOrder() {
                this.$router.push({
                    name: 'v2.activation.brief.products',
                    params: {isAdditionalOrder: true}
                });
            },
        }
    };
</script>
